<template>
  <div>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="新建活动(全局)" name="1">
        <global-event-program ref="eventProgram" :currentGlobalOperation="null"></global-event-program>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import globalEventProgram from '../dot/order/taskTemplate/global-event-program'
import {mapGetters} from "vuex";
export default {
  components: {globalEventProgram},
  data() {
    return {
      activeName: "1",
    }
  },
  methods: {
    handleClick(tab, event) {
        this.$refs.eventProgram.init();
    },
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  filters: {},
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}
</style>
